import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _128f4759 = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _0fae00d3 = () => interopDefault(import('../pages/agreement.vue' /* webpackChunkName: "pages/agreement" */))
const _5592076c = () => interopDefault(import('../pages/business/index.vue' /* webpackChunkName: "pages/business/index" */))
const _ed13f1de = () => interopDefault(import('../pages/car-charging.vue' /* webpackChunkName: "pages/car-charging" */))
const _4056afca = () => interopDefault(import('../pages/certificate-of-safety.vue' /* webpackChunkName: "pages/certificate-of-safety" */))
const _2e5096b3 = () => interopDefault(import('../pages/check-your-app.vue' /* webpackChunkName: "pages/check-your-app" */))
const _665e9250 = () => interopDefault(import('../pages/currency.vue' /* webpackChunkName: "pages/currency" */))
const _2aa7bab2 = () => interopDefault(import('../pages/customer-survey.vue' /* webpackChunkName: "pages/customer-survey" */))
const _11a3ffba = () => interopDefault(import('../pages/dbo.vue' /* webpackChunkName: "pages/dbo" */))
const _27f147b4 = () => interopDefault(import('../pages/deposit-insurance.vue' /* webpackChunkName: "pages/deposit-insurance" */))
const _6b42dc44 = () => interopDefault(import('../pages/documents/index.vue' /* webpackChunkName: "pages/documents/index" */))
const _a4b482f6 = () => interopDefault(import('../pages/esg/index.vue' /* webpackChunkName: "pages/esg/index" */))
const _45c254a3 = () => interopDefault(import('../pages/financial-commissioner.vue' /* webpackChunkName: "pages/financial-commissioner" */))
const _0ed06ea1 = () => interopDefault(import('../pages/googlepay-mir.vue' /* webpackChunkName: "pages/googlepay-mir" */))
const _406e52c6 = () => interopDefault(import('../pages/history.vue' /* webpackChunkName: "pages/history" */))
const _e1027378 = () => interopDefault(import('../pages/internetbank.vue' /* webpackChunkName: "pages/internetbank" */))
const _a872ec72 = () => interopDefault(import('../pages/internetbank/index.vue' /* webpackChunkName: "pages/internetbank/index" */))
const _756e2cde = () => interopDefault(import('../pages/internetbank/login.vue' /* webpackChunkName: "pages/internetbank/login" */))
const _7e7b6ba8 = () => interopDefault(import('../pages/internetbank/payments-doc-list.vue' /* webpackChunkName: "pages/internetbank/payments-doc-list" */))
const _d71373f2 = () => interopDefault(import('../pages/internetbank/_scenarioType/cabinet.vue' /* webpackChunkName: "pages/internetbank/_scenarioType/cabinet" */))
const _d6cca328 = () => interopDefault(import('../pages/internetbank/_scenarioType/cabinet/charge.vue' /* webpackChunkName: "pages/internetbank/_scenarioType/cabinet/charge" */))
const _35993123 = () => interopDefault(import('../pages/internetbank/_scenarioType/cabinet/chargeRub.vue' /* webpackChunkName: "pages/internetbank/_scenarioType/cabinet/chargeRub" */))
const _04363d49 = () => interopDefault(import('../pages/internetbank/_scenarioType/cabinet/currency.vue' /* webpackChunkName: "pages/internetbank/_scenarioType/cabinet/currency" */))
const _26ef3e6e = () => interopDefault(import('../pages/internetbank/_scenarioType/cabinet/newCurrency.vue' /* webpackChunkName: "pages/internetbank/_scenarioType/cabinet/newCurrency" */))
const _a8912336 = () => interopDefault(import('../pages/internetbank/_scenarioType/cabinet/payments.vue' /* webpackChunkName: "pages/internetbank/_scenarioType/cabinet/payments" */))
const _0d49210a = () => interopDefault(import('../pages/internetbank/_scenarioType/cabinet/score.vue' /* webpackChunkName: "pages/internetbank/_scenarioType/cabinet/score" */))
const _2fb69f4a = () => interopDefault(import('../pages/internetbank/_scenarioType/cabinet/settings.vue' /* webpackChunkName: "pages/internetbank/_scenarioType/cabinet/settings" */))
const _3f5e920d = () => interopDefault(import('../pages/nadzorniy_organ.vue' /* webpackChunkName: "pages/nadzorniy_organ" */))
const _6294f880 = () => interopDefault(import('../pages/presentation-information.vue' /* webpackChunkName: "pages/presentation-information" */))
const _2673e8af = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _6b33fd26 = () => interopDefault(import('../pages/social-projects/index.vue' /* webpackChunkName: "pages/social-projects/index" */))
const _749e70aa = () => interopDefault(import('../pages/start.vue' /* webpackChunkName: "pages/start" */))
const _37d0b9da = () => interopDefault(import('../pages/support-measures.vue' /* webpackChunkName: "pages/support-measures" */))
const _28a10161 = () => interopDefault(import('../pages/survey.vue' /* webpackChunkName: "pages/survey" */))
const _ae869858 = () => interopDefault(import('../pages/survey-tips.vue' /* webpackChunkName: "pages/survey-tips" */))
const _085cd44c = () => interopDefault(import('../pages/unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */))
const _69c6d642 = () => interopDefault(import('../pages/wifi/index.vue' /* webpackChunkName: "pages/wifi/index" */))
const _3134784c = () => interopDefault(import('../pages/about/books-articles/index.vue' /* webpackChunkName: "pages/about/books-articles/index" */))
const _cf4998c2 = () => interopDefault(import('../pages/about/contacts/index.vue' /* webpackChunkName: "pages/about/contacts/index" */))
const _2f873d25 = () => interopDefault(import('../pages/about/events/index.vue' /* webpackChunkName: "pages/about/events/index" */))
const _7b52e665 = () => interopDefault(import('../pages/about/investors/index.vue' /* webpackChunkName: "pages/about/investors/index" */))
const _7df428d7 = () => interopDefault(import('../pages/about/mass-media/index.vue' /* webpackChunkName: "pages/about/mass-media/index" */))
const _6b84daf1 = () => interopDefault(import('../pages/about/offices-and-atms/index.vue' /* webpackChunkName: "pages/about/offices-and-atms/index" */))
const _6bcec94d = () => interopDefault(import('../pages/about/press/index.vue' /* webpackChunkName: "pages/about/press/index" */))
const _3e5a3662 = () => interopDefault(import('../pages/about/press-releases/index.vue' /* webpackChunkName: "pages/about/press-releases/index" */))
const _018bcd4e = () => interopDefault(import('../pages/business/acquiring/index.vue' /* webpackChunkName: "pages/business/acquiring/index" */))
const _566dc498 = () => interopDefault(import('../pages/business/bank-agreement/index.vue' /* webpackChunkName: "pages/business/bank-agreement/index" */))
const _7bb16dd2 = () => interopDefault(import('../pages/business/bank-guarantees/index.vue' /* webpackChunkName: "pages/business/bank-guarantees/index" */))
const _57fa66b7 = () => interopDefault(import('../pages/business/business-crediting/index.vue' /* webpackChunkName: "pages/business/business-crediting/index" */))
const _2758a679 = () => interopDefault(import('../pages/business/client-bank/index.vue' /* webpackChunkName: "pages/business/client-bank/index" */))
const _1b88e736 = () => interopDefault(import('../pages/business/corporate-cards/index.vue' /* webpackChunkName: "pages/business/corporate-cards/index" */))
const _5ea46867 = () => interopDefault(import('../pages/business/credit-holidays.vue' /* webpackChunkName: "pages/business/credit-holidays" */))
const _6914077c = () => interopDefault(import('../pages/business/energy-saving-investment/index.vue' /* webpackChunkName: "pages/business/energy-saving-investment/index" */))
const _0f07139b = () => interopDefault(import('../pages/business/fz106.vue' /* webpackChunkName: "pages/business/fz106" */))
const _f658e412 = () => interopDefault(import('../pages/business/fz377.vue' /* webpackChunkName: "pages/business/fz377" */))
const _69a93102 = () => interopDefault(import('../pages/business/internet-acquiring/index.vue' /* webpackChunkName: "pages/business/internet-acquiring/index" */))
const _28a25e36 = () => interopDefault(import('../pages/business/lead-magnet/index.vue' /* webpackChunkName: "pages/business/lead-magnet/index" */))
const _f286e65c = () => interopDefault(import('../pages/business/leasing/index.vue' /* webpackChunkName: "pages/business/leasing/index" */))
const _c1ec3732 = () => interopDefault(import('../pages/business/opening-and-maintaining-account/index.vue' /* webpackChunkName: "pages/business/opening-and-maintaining-account/index" */))
const _2020f0fa = () => interopDefault(import('../pages/business/opening-and-maintaining-account-new/index.vue' /* webpackChunkName: "pages/business/opening-and-maintaining-account-new/index" */))
const _332b2000 = () => interopDefault(import('../pages/business/payment-qr.vue' /* webpackChunkName: "pages/business/payment-qr" */))
const _23104aef = () => interopDefault(import('../pages/business/payments-from-individuals.vue' /* webpackChunkName: "pages/business/payments-from-individuals" */))
const _2c9231fc = () => interopDefault(import('../pages/business/placement-of-funds-and-securities/index.vue' /* webpackChunkName: "pages/business/placement-of-funds-and-securities/index" */))
const _57ec35d8 = () => interopDefault(import('../pages/business/salary-projects/index.vue' /* webpackChunkName: "pages/business/salary-projects/index" */))
const _b66e60ee = () => interopDefault(import('../pages/business/self-employed/index.vue' /* webpackChunkName: "pages/business/self-employed/index" */))
const _057c8c69 = () => interopDefault(import('../pages/business/trade-finance.vue' /* webpackChunkName: "pages/business/trade-finance" */))
const _7ada7aaa = () => interopDefault(import('../pages/business/transfer-b2b/index.vue' /* webpackChunkName: "pages/business/transfer-b2b/index" */))
const _9d87bf60 = () => interopDefault(import('../pages/business/web-tsp.vue' /* webpackChunkName: "pages/business/web-tsp" */))
const _ffdee0d6 = () => interopDefault(import('../pages/documents/dkbo/index.vue' /* webpackChunkName: "pages/documents/dkbo/index" */))
const _12f80b5a = () => interopDefault(import('../pages/esg/esg-library.vue' /* webpackChunkName: "pages/esg/esg-library" */))
const _6dd5774e = () => interopDefault(import('../pages/esg/esg-rating.vue' /* webpackChunkName: "pages/esg/esg-rating" */))
const _f7169a42 = () => interopDefault(import('../pages/for-individuals/biometric-data.vue' /* webpackChunkName: "pages/for-individuals/biometric-data" */))
const _ba67a0d4 = () => interopDefault(import('../pages/for-individuals/cards/index.vue' /* webpackChunkName: "pages/for-individuals/cards/index" */))
const _e6d91b4a = () => interopDefault(import('../pages/for-individuals/centr-invest-online/index.vue' /* webpackChunkName: "pages/for-individuals/centr-invest-online/index" */))
const _087dda08 = () => interopDefault(import('../pages/for-individuals/crediting/index.vue' /* webpackChunkName: "pages/for-individuals/crediting/index" */))
const _4e223b5a = () => interopDefault(import('../pages/for-individuals/currency-rates/index.vue' /* webpackChunkName: "pages/for-individuals/currency-rates/index" */))
const _11549e98 = () => interopDefault(import('../pages/for-individuals/deposits/index.vue' /* webpackChunkName: "pages/for-individuals/deposits/index" */))
const _0f25dec0 = () => interopDefault(import('../pages/for-individuals/internet-bank-service.vue' /* webpackChunkName: "pages/for-individuals/internet-bank-service" */))
const _7accd5ba = () => interopDefault(import('../pages/for-individuals/mobile-bank/index.vue' /* webpackChunkName: "pages/for-individuals/mobile-bank/index" */))
const _06a2ad4e = () => interopDefault(import('../pages/for-individuals/money-transfers/index.vue' /* webpackChunkName: "pages/for-individuals/money-transfers/index" */))
const _128038df = () => interopDefault(import('../pages/for-individuals/mortgage/index.vue' /* webpackChunkName: "pages/for-individuals/mortgage/index" */))
const _f72bd166 = () => interopDefault(import('../pages/for-individuals/online-applications.vue' /* webpackChunkName: "pages/for-individuals/online-applications" */))
const _357d7b70 = () => interopDefault(import('../pages/for-individuals/property-deduction/index.vue' /* webpackChunkName: "pages/for-individuals/property-deduction/index" */))
const _4a18ce1a = () => interopDefault(import('../pages/for-individuals/reference-information.vue' /* webpackChunkName: "pages/for-individuals/reference-information" */))
const _5b738b92 = () => interopDefault(import('../pages/for-individuals/refinancing/index.vue' /* webpackChunkName: "pages/for-individuals/refinancing/index" */))
const _66293908 = () => interopDefault(import('../pages/for-individuals/safe-boxes/index.vue' /* webpackChunkName: "pages/for-individuals/safe-boxes/index" */))
const _b0490676 = () => interopDefault(import('../pages/for-individuals/sale-of-coins/index.vue' /* webpackChunkName: "pages/for-individuals/sale-of-coins/index" */))
const _717567a1 = () => interopDefault(import('../pages/for-individuals/securities/index.vue' /* webpackChunkName: "pages/for-individuals/securities/index" */))
const _005afea4 = () => interopDefault(import('../pages/for-individuals/service-rates/index.vue' /* webpackChunkName: "pages/for-individuals/service-rates/index" */))
const _904a4f98 = () => interopDefault(import('../pages/for-individuals/tariffs-and-documents.vue' /* webpackChunkName: "pages/for-individuals/tariffs-and-documents" */))
const _00e967b7 = () => interopDefault(import('../pages/for-individuals/tariffs-and-documents/index.vue' /* webpackChunkName: "pages/for-individuals/tariffs-and-documents/index" */))
const _9d9d0560 = () => interopDefault(import('../pages/for-individuals/tariffs-and-documents/cards-docs.vue' /* webpackChunkName: "pages/for-individuals/tariffs-and-documents/cards-docs" */))
const _b6a4868e = () => interopDefault(import('../pages/for-individuals/tariffs-and-documents/dkbo-docs.vue' /* webpackChunkName: "pages/for-individuals/tariffs-and-documents/dkbo-docs" */))
const _1016720b = () => interopDefault(import('../pages/for-individuals/tariffs-and-documents/internet-bank-docs.vue' /* webpackChunkName: "pages/for-individuals/tariffs-and-documents/internet-bank-docs" */))
const _7b64966c = () => interopDefault(import('../pages/for-individuals/tariffs-and-documents/mobile-bank-docs.vue' /* webpackChunkName: "pages/for-individuals/tariffs-and-documents/mobile-bank-docs" */))
const _076c02ca = () => interopDefault(import('../pages/for-individuals/tariffs-and-documents/payment-terminal-docs.vue' /* webpackChunkName: "pages/for-individuals/tariffs-and-documents/payment-terminal-docs" */))
const _4c68a416 = () => interopDefault(import('../pages/for-individuals/vip-service.vue' /* webpackChunkName: "pages/for-individuals/vip-service" */))
const _39f4ff6e = () => interopDefault(import('../pages/promotions/new-clients-acquiring.vue' /* webpackChunkName: "pages/promotions/new-clients-acquiring" */))
const _9f09837a = () => interopDefault(import('../pages/promotions/online-cashbox-free.vue' /* webpackChunkName: "pages/promotions/online-cashbox-free" */))
const _cd4d5bc2 = () => interopDefault(import('../pages/promotions/resort-acquiring.vue' /* webpackChunkName: "pages/promotions/resort-acquiring" */))
const _2d13a556 = () => interopDefault(import('../pages/promotions/starting-business.vue' /* webpackChunkName: "pages/promotions/starting-business" */))
const _4b9b47da = () => interopDefault(import('../pages/social-projects/career.vue' /* webpackChunkName: "pages/social-projects/career" */))
const _5dca0378 = () => interopDefault(import('../pages/social-projects/medical-professionals.vue' /* webpackChunkName: "pages/social-projects/medical-professionals" */))
const _45f7721a = () => interopDefault(import('../pages/wifi/avto.vue' /* webpackChunkName: "pages/wifi/avto" */))
const _2105852a = () => interopDefault(import('../pages/about/investors/experience/index.vue' /* webpackChunkName: "pages/about/investors/experience/index" */))
const _e6bf22a4 = () => interopDefault(import('../pages/about/investors/international-activity/index.vue' /* webpackChunkName: "pages/about/investors/international-activity/index" */))
const _1f0c95c9 = () => interopDefault(import('../pages/about/investors/meetings-of-shareholders/index.vue' /* webpackChunkName: "pages/about/investors/meetings-of-shareholders/index" */))
const _e65c8412 = () => interopDefault(import('../pages/about/investors/principles/index.vue' /* webpackChunkName: "pages/about/investors/principles/index" */))
const _5ba4517e = () => interopDefault(import('../pages/about/investors/pub-info/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/index" */))
const _37c703fa = () => interopDefault(import('../pages/about/investors/registrar/index.vue' /* webpackChunkName: "pages/about/investors/registrar/index" */))
const _0198f7a4 = () => interopDefault(import('../pages/about/investors/regulatory-purp/index.vue' /* webpackChunkName: "pages/about/investors/regulatory-purp/index" */))
const _3e62ef15 = () => interopDefault(import('../pages/about/investors/reports/index.vue' /* webpackChunkName: "pages/about/investors/reports/index" */))
const _d23c8ef0 = () => interopDefault(import('../pages/about/investors/shareholders/index.vue' /* webpackChunkName: "pages/about/investors/shareholders/index" */))
const _076739d6 = () => interopDefault(import('../pages/about/investors/shareholders-notices/index.vue' /* webpackChunkName: "pages/about/investors/shareholders-notices/index" */))
const _08255d78 = () => interopDefault(import('../pages/about/investors/struct-controls/index.vue' /* webpackChunkName: "pages/about/investors/struct-controls/index" */))
const _61776709 = () => interopDefault(import('../pages/about/investors/structure/index.vue' /* webpackChunkName: "pages/about/investors/structure/index" */))
const _152ff5b4 = () => interopDefault(import('../pages/business/acquiring/instructionsqrlink.vue' /* webpackChunkName: "pages/business/acquiring/instructionsqrlink" */))
const _7d059e5c = () => interopDefault(import('../pages/business/bank-agreement/form.vue' /* webpackChunkName: "pages/business/bank-agreement/form" */))
const _3d41fea3 = () => interopDefault(import('../pages/business/bank-agreement/sign-bki-form.vue' /* webpackChunkName: "pages/business/bank-agreement/sign-bki-form" */))
const _9af36352 = () => interopDefault(import('../pages/business/client-bank/info.vue' /* webpackChunkName: "pages/business/client-bank/info" */))
const _5b5870a3 = () => interopDefault(import('../pages/business/opening-and-maintaining-account/rko-currency.vue' /* webpackChunkName: "pages/business/opening-and-maintaining-account/rko-currency" */))
const _48d1f917 = () => interopDefault(import('../pages/business/opening-and-maintaining-account/rko-special.vue' /* webpackChunkName: "pages/business/opening-and-maintaining-account/rko-special" */))
const _1fff1a8c = () => interopDefault(import('../pages/for-individuals/cards/additional-card.vue' /* webpackChunkName: "pages/for-individuals/cards/additional-card" */))
const _01a42d21 = () => interopDefault(import('../pages/for-individuals/cards/card-features/index.vue' /* webpackChunkName: "pages/for-individuals/cards/card-features/index" */))
const _c5407a42 = () => interopDefault(import('../pages/for-individuals/cards/concierge-service.vue' /* webpackChunkName: "pages/for-individuals/cards/concierge-service" */))
const _5406e2e6 = () => interopDefault(import('../pages/for-individuals/cards/debet-cards/index.vue' /* webpackChunkName: "pages/for-individuals/cards/debet-cards/index" */))
const _92fe3596 = () => interopDefault(import('../pages/for-individuals/cards/rerelease-card.vue' /* webpackChunkName: "pages/for-individuals/cards/rerelease-card" */))
const _0eb95d2c = () => interopDefault(import('../pages/for-individuals/cards/security.vue' /* webpackChunkName: "pages/for-individuals/cards/security" */))
const _5fad0422 = () => interopDefault(import('../pages/for-individuals/cards/short-card-request.vue' /* webpackChunkName: "pages/for-individuals/cards/short-card-request" */))
const _2c056b58 = () => interopDefault(import('../pages/for-individuals/cards/student-cards/index.vue' /* webpackChunkName: "pages/for-individuals/cards/student-cards/index" */))
const _1c0d2487 = () => interopDefault(import('../pages/for-individuals/cards/teacher-card.vue' /* webpackChunkName: "pages/for-individuals/cards/teacher-card" */))
const _126432f7 = () => interopDefault(import('../pages/for-individuals/crediting/car-loans/index.vue' /* webpackChunkName: "pages/for-individuals/crediting/car-loans/index" */))
const _3acec7d4 = () => interopDefault(import('../pages/for-individuals/crediting/consumer-loan/index.vue' /* webpackChunkName: "pages/for-individuals/crediting/consumer-loan/index" */))
const _1bc3d498 = () => interopDefault(import('../pages/for-individuals/crediting/credit-cards/index.vue' /* webpackChunkName: "pages/for-individuals/crediting/credit-cards/index" */))
const _31bfe20c = () => interopDefault(import('../pages/for-individuals/crediting/na-1-god.vue' /* webpackChunkName: "pages/for-individuals/crediting/na-1-god" */))
const _2dc716f8 = () => interopDefault(import('../pages/for-individuals/crediting/paket-dokumentov.vue' /* webpackChunkName: "pages/for-individuals/crediting/paket-dokumentov" */))
const _2247781c = () => interopDefault(import('../pages/for-individuals/crediting/remote-payment-methods-for-loans.vue' /* webpackChunkName: "pages/for-individuals/crediting/remote-payment-methods-for-loans" */))
const _d6665f26 = () => interopDefault(import('../pages/for-individuals/crediting/repayment-credits/index.vue' /* webpackChunkName: "pages/for-individuals/crediting/repayment-credits/index" */))
const _308b6b90 = () => interopDefault(import('../pages/for-individuals/crediting/self-employed.vue' /* webpackChunkName: "pages/for-individuals/crediting/self-employed" */))
const _595d31e1 = () => interopDefault(import('../pages/for-individuals/crediting/service-tariffs.vue' /* webpackChunkName: "pages/for-individuals/crediting/service-tariffs" */))
const _150350af = () => interopDefault(import('../pages/for-individuals/crediting/useful-info.vue' /* webpackChunkName: "pages/for-individuals/crediting/useful-info" */))
const _7c2fff4a = () => interopDefault(import('../pages/for-individuals/currency-rates/archive.vue' /* webpackChunkName: "pages/for-individuals/currency-rates/archive" */))
const _7e37b6b2 = () => interopDefault(import('../pages/for-individuals/money-transfers/golden-crown.vue' /* webpackChunkName: "pages/for-individuals/money-transfers/golden-crown" */))
const _04312a10 = () => interopDefault(import('../pages/for-individuals/money-transfers/western-union.vue' /* webpackChunkName: "pages/for-individuals/money-transfers/western-union" */))
const _1b5cf9e7 = () => interopDefault(import('../pages/for-individuals/mortgage/bank-programm.vue' /* webpackChunkName: "pages/for-individuals/mortgage/bank-programm" */))
const _a7fab692 = () => interopDefault(import('../pages/for-individuals/mortgage/building.vue' /* webpackChunkName: "pages/for-individuals/mortgage/building" */))
const _6ee75545 = () => interopDefault(import('../pages/for-individuals/mortgage/commercial-property.vue' /* webpackChunkName: "pages/for-individuals/mortgage/commercial-property" */))
const _56fcae2e = () => interopDefault(import('../pages/for-individuals/mortgage/green-mortgage.vue' /* webpackChunkName: "pages/for-individuals/mortgage/green-mortgage" */))
const _bde80d6a = () => interopDefault(import('../pages/for-individuals/mortgage/it-mortgage.vue' /* webpackChunkName: "pages/for-individuals/mortgage/it-mortgage" */))
const _13fea1a4 = () => interopDefault(import('../pages/for-individuals/mortgage/it-mortgage-bank.vue' /* webpackChunkName: "pages/for-individuals/mortgage/it-mortgage-bank" */))
const _50a3548e = () => interopDefault(import('../pages/for-individuals/mortgage/large-family.vue' /* webpackChunkName: "pages/for-individuals/mortgage/large-family" */))
const _39a3460a = () => interopDefault(import('../pages/for-individuals/mortgage/maternal-capital.vue' /* webpackChunkName: "pages/for-individuals/mortgage/maternal-capital" */))
const _98114ff8 = () => interopDefault(import('../pages/for-individuals/mortgage/mortgage-2.vue' /* webpackChunkName: "pages/for-individuals/mortgage/mortgage-2" */))
const _a22754c6 = () => interopDefault(import('../pages/for-individuals/mortgage/mortgage-children.vue' /* webpackChunkName: "pages/for-individuals/mortgage/mortgage-children" */))
const _7e28ce60 = () => interopDefault(import('../pages/for-individuals/mortgage/mortgage-combo.vue' /* webpackChunkName: "pages/for-individuals/mortgage/mortgage-combo" */))
const _50552a76 = () => interopDefault(import('../pages/for-individuals/mortgage/mortgage-excellent-student.vue' /* webpackChunkName: "pages/for-individuals/mortgage/mortgage-excellent-student" */))
const _2e0e5094 = () => interopDefault(import('../pages/for-individuals/mortgage/mortgage-gc-a101.vue' /* webpackChunkName: "pages/for-individuals/mortgage/mortgage-gc-a101" */))
const _3afc0c67 = () => interopDefault(import('../pages/for-individuals/mortgage/mortgage-gc-pioneer.vue' /* webpackChunkName: "pages/for-individuals/mortgage/mortgage-gc-pioneer" */))
const _7b551429 = () => interopDefault(import('../pages/for-individuals/mortgage/mortgage-neometry.vue' /* webpackChunkName: "pages/for-individuals/mortgage/mortgage-neometry" */))
const _0bb82311 = () => interopDefault(import('../pages/for-individuals/mortgage/mosprime.vue' /* webpackChunkName: "pages/for-individuals/mortgage/mosprime" */))
const _56546e79 = () => interopDefault(import('../pages/for-individuals/mortgage/village.vue' /* webpackChunkName: "pages/for-individuals/mortgage/village" */))
const _13afa8d4 = () => interopDefault(import('../pages/for-individuals/property-deduction/form.vue' /* webpackChunkName: "pages/for-individuals/property-deduction/form" */))
const _97623f4a = () => interopDefault(import('../pages/for-individuals/refinancing/credit-refinancing.vue' /* webpackChunkName: "pages/for-individuals/refinancing/credit-refinancing" */))
const _4df4bb3e = () => interopDefault(import('../pages/for-individuals/refinancing/mortgage-refinancing.vue' /* webpackChunkName: "pages/for-individuals/refinancing/mortgage-refinancing" */))
const _7184d168 = () => interopDefault(import('../pages/for-individuals/service-rates/currency-rf.vue' /* webpackChunkName: "pages/for-individuals/service-rates/currency-rf" */))
const _06659dbe = () => interopDefault(import('../pages/for-individuals/service-rates/foreign-currency.vue' /* webpackChunkName: "pages/for-individuals/service-rates/foreign-currency" */))
const _43ac723c = () => interopDefault(import('../pages/for-individuals/service-rates/tariff-terminals.vue' /* webpackChunkName: "pages/for-individuals/service-rates/tariff-terminals" */))
const _61c01dde = () => interopDefault(import('../pages/for-individuals/services/real-estate-valuation.vue' /* webpackChunkName: "pages/for-individuals/services/real-estate-valuation" */))
const _4d3f27d6 = () => interopDefault(import('../pages/about/investors/pub-info/bailee-docs/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/bailee-docs/index" */))
const _3367cfe4 = () => interopDefault(import('../pages/about/investors/pub-info/bank-info/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/bank-info/index" */))
const _622f4da3 = () => interopDefault(import('../pages/about/investors/pub-info/bank-management/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/bank-management/index" */))
const _861755c4 = () => interopDefault(import('../pages/about/investors/pub-info/broker-docs/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/broker-docs/index" */))
const _6864d117 = () => interopDefault(import('../pages/about/investors/pub-info/cliring-organization/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/cliring-organization/index" */))
const _77d9a2f4 = () => interopDefault(import('../pages/about/investors/pub-info/info-regulatory/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/info-regulatory/index" */))
const _5f0f529b = () => interopDefault(import('../pages/about/investors/pub-info/inside-docs/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/inside-docs/index" */))
const _16052fee = () => interopDefault(import('../pages/about/investors/pub-info/kred-organization/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/kred-organization/index" */))
const _3e00974e = () => interopDefault(import('../pages/about/investors/pub-info/licenses/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/licenses/index" */))
const _477149bc = () => interopDefault(import('../pages/about/investors/pub-info/manager-docs/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/manager-docs/index" */))
const _25a08d51 = () => interopDefault(import('../pages/about/investors/pub-info/measure-docs/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/measure-docs/index" */))
const _a0627ebc = () => interopDefault(import('../pages/about/investors/pub-info/organiz-torg/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/organiz-torg/index" */))
const _d58f2b86 = () => interopDefault(import('../pages/about/investors/pub-info/polojenie-kval/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/polojenie-kval/index" */))
const _774cfcf8 = () => interopDefault(import('../pages/about/investors/pub-info/registr-depo/index.vue' /* webpackChunkName: "pages/about/investors/pub-info/registr-depo/index" */))
const _1061cd0e = () => interopDefault(import('../pages/about/investors/struct-controls/board-of-directors/index.vue' /* webpackChunkName: "pages/about/investors/struct-controls/board-of-directors/index" */))
const _6c664880 = () => interopDefault(import('../pages/for-individuals/cards/card-features/mir-pay.vue' /* webpackChunkName: "pages/for-individuals/cards/card-features/mir-pay" */))
const _02be6114 = () => interopDefault(import('../pages/for-individuals/cards/card-features/mirpass.vue' /* webpackChunkName: "pages/for-individuals/cards/card-features/mirpass" */))
const _d1c07690 = () => interopDefault(import('../pages/for-individuals/cards/debet-cards/sticker.vue' /* webpackChunkName: "pages/for-individuals/cards/debet-cards/sticker" */))
const _20247bb7 = () => interopDefault(import('../pages/for-individuals/crediting/consumer-loan/car-loan.vue' /* webpackChunkName: "pages/for-individuals/crediting/consumer-loan/car-loan" */))
const _4de8ebb7 = () => interopDefault(import('../pages/for-individuals/crediting/consumer-loan/credit-for-all.vue' /* webpackChunkName: "pages/for-individuals/crediting/consumer-loan/credit-for-all" */))
const _0568af65 = () => interopDefault(import('../pages/for-individuals/crediting/consumer-loan/credit-marketplace.vue' /* webpackChunkName: "pages/for-individuals/crediting/consumer-loan/credit-marketplace" */))
const _317d79bb = () => interopDefault(import('../pages/for-individuals/crediting/consumer-loan/potreb-goals.vue' /* webpackChunkName: "pages/for-individuals/crediting/consumer-loan/potreb-goals" */))
const _8ef38e8e = () => interopDefault(import('../pages/for-individuals/crediting/credit-cards/credit-cards.vue' /* webpackChunkName: "pages/for-individuals/crediting/credit-cards/credit-cards" */))
const _2745acca = () => interopDefault(import('../pages/for-individuals/crediting/repayment-credits/credit-holidays.vue' /* webpackChunkName: "pages/for-individuals/crediting/repayment-credits/credit-holidays" */))
const _7f00002d = () => interopDefault(import('../pages/for-individuals/crediting/repayment-credits/fz-credit.vue' /* webpackChunkName: "pages/for-individuals/crediting/repayment-credits/fz-credit" */))
const _5f3c5002 = () => interopDefault(import('../pages/for-individuals/crediting/repayment-credits/fz-delay.vue' /* webpackChunkName: "pages/for-individuals/crediting/repayment-credits/fz-delay" */))
const _c6bead60 = () => interopDefault(import('../pages/for-individuals/crediting/repayment-credits/fz-mortgage.vue' /* webpackChunkName: "pages/for-individuals/crediting/repayment-credits/fz-mortgage" */))
const _1ce546ce = () => interopDefault(import('../pages/for-individuals/crediting/repayment-credits/fz-potreb.vue' /* webpackChunkName: "pages/for-individuals/crediting/repayment-credits/fz-potreb" */))
const _9f96d710 = () => interopDefault(import('../pages/for-individuals/crediting/repayment-credits/restructuring.vue' /* webpackChunkName: "pages/for-individuals/crediting/repayment-credits/restructuring" */))
const _1479741b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7d54b116 = () => interopDefault(import('../pages/for-individuals/crediting/credit-cards/card/_slug.vue' /* webpackChunkName: "pages/for-individuals/crediting/credit-cards/card/_slug" */))
const _57742576 = () => interopDefault(import('../pages/for-individuals/cards/debet-cards/_slug.vue' /* webpackChunkName: "pages/for-individuals/cards/debet-cards/_slug" */))
const _2a4eca10 = () => interopDefault(import('../pages/for-individuals/cards/student-cards/_slug.vue' /* webpackChunkName: "pages/for-individuals/cards/student-cards/_slug" */))
const _10ad91af = () => interopDefault(import('../pages/for-individuals/crediting/car-loans/_slug.vue' /* webpackChunkName: "pages/for-individuals/crediting/car-loans/_slug" */))
const _3918268c = () => interopDefault(import('../pages/for-individuals/crediting/consumer-loan/_slug.vue' /* webpackChunkName: "pages/for-individuals/crediting/consumer-loan/_slug" */))
const _1a0d3350 = () => interopDefault(import('../pages/for-individuals/crediting/credit-cards/_slug.vue' /* webpackChunkName: "pages/for-individuals/crediting/credit-cards/_slug" */))
const _2fe9efe7 = () => interopDefault(import('../pages/for-individuals/securities/exchange-traded-bonds/_id.vue' /* webpackChunkName: "pages/for-individuals/securities/exchange-traded-bonds/_id" */))
const _2f7dd704 = () => interopDefault(import('../pages/about/books-articles/_slug.vue' /* webpackChunkName: "pages/about/books-articles/_slug" */))
const _7c3d878f = () => interopDefault(import('../pages/about/mass-media/_slug.vue' /* webpackChunkName: "pages/about/mass-media/_slug" */))
const _69ce39a9 = () => interopDefault(import('../pages/about/offices-and-atms/_slug.vue' /* webpackChunkName: "pages/about/offices-and-atms/_slug" */))
const _3ca3951a = () => interopDefault(import('../pages/about/press-releases/_slug.vue' /* webpackChunkName: "pages/about/press-releases/_slug" */))
const _5643c56f = () => interopDefault(import('../pages/business/business-crediting/_slug.vue' /* webpackChunkName: "pages/business/business-crediting/_slug" */))
const _2adb90b4 = () => interopDefault(import('../pages/business/placement-of-funds-and-securities/_slug.vue' /* webpackChunkName: "pages/business/placement-of-funds-and-securities/_slug" */))
const _7e59ee4d = () => interopDefault(import('../pages/documents/dkbo/_slug.vue' /* webpackChunkName: "pages/documents/dkbo/_slug" */))
const _4a2b47d3 = () => interopDefault(import('../pages/for-individuals/deposits/_slug/index.vue' /* webpackChunkName: "pages/for-individuals/deposits/_slug/index" */))
const _10c99797 = () => interopDefault(import('../pages/for-individuals/mortgage/_slug.vue' /* webpackChunkName: "pages/for-individuals/mortgage/_slug" */))
const _0f993972 = () => interopDefault(import('../pages/for-individuals/deposits/_slug/banki-ru.vue' /* webpackChunkName: "pages/for-individuals/deposits/_slug/banki-ru" */))
const _4afc8bf0 = () => interopDefault(import('../pages/for-individuals/deposits/_slug/new-offer.vue' /* webpackChunkName: "pages/for-individuals/deposits/_slug/new-offer" */))
const _698c3afc = () => interopDefault(import('../pages/documents/_slug.vue' /* webpackChunkName: "pages/documents/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _128f4759,
    name: "about"
  }, {
    path: "/agreement",
    component: _0fae00d3,
    name: "agreement"
  }, {
    path: "/business",
    component: _5592076c,
    name: "business"
  }, {
    path: "/car-charging",
    component: _ed13f1de,
    name: "car-charging"
  }, {
    path: "/certificate-of-safety",
    component: _4056afca,
    name: "certificate-of-safety"
  }, {
    path: "/check-your-app",
    component: _2e5096b3,
    name: "check-your-app"
  }, {
    path: "/currency",
    component: _665e9250,
    name: "currency"
  }, {
    path: "/customer-survey",
    component: _2aa7bab2,
    name: "customer-survey"
  }, {
    path: "/dbo",
    component: _11a3ffba,
    name: "dbo"
  }, {
    path: "/deposit-insurance",
    component: _27f147b4,
    name: "deposit-insurance"
  }, {
    path: "/documents",
    component: _6b42dc44,
    name: "documents"
  }, {
    path: "/esg",
    component: _a4b482f6,
    name: "esg"
  }, {
    path: "/financial-commissioner",
    component: _45c254a3,
    name: "financial-commissioner"
  }, {
    path: "/googlepay-mir",
    component: _0ed06ea1,
    name: "googlepay-mir"
  }, {
    path: "/history",
    component: _406e52c6,
    name: "history"
  }, {
    path: "/internetbank",
    component: _e1027378,
    children: [{
      path: "",
      component: _a872ec72,
      name: "internetbank"
    }, {
      path: "login",
      component: _756e2cde,
      name: "internetbank-login"
    }, {
      path: "payments-doc-list",
      component: _7e7b6ba8,
      name: "internetbank-payments-doc-list"
    }, {
      path: ":scenarioType/cabinet",
      component: _d71373f2,
      name: "internetbank-scenarioType-cabinet",
      children: [{
        path: "charge",
        component: _d6cca328,
        name: "internetbank-scenarioType-cabinet-charge"
      }, {
        path: "chargeRub",
        component: _35993123,
        name: "internetbank-scenarioType-cabinet-chargeRub"
      }, {
        path: "currency",
        component: _04363d49,
        name: "internetbank-scenarioType-cabinet-currency"
      }, {
        path: "newCurrency",
        component: _26ef3e6e,
        name: "internetbank-scenarioType-cabinet-newCurrency"
      }, {
        path: "payments",
        component: _a8912336,
        name: "internetbank-scenarioType-cabinet-payments"
      }, {
        path: "score",
        component: _0d49210a,
        name: "internetbank-scenarioType-cabinet-score"
      }, {
        path: "settings",
        component: _2fb69f4a,
        name: "internetbank-scenarioType-cabinet-settings"
      }]
    }]
  }, {
    path: "/nadzorniy_organ",
    component: _3f5e920d,
    name: "nadzorniy_organ"
  }, {
    path: "/presentation-information",
    component: _6294f880,
    name: "presentation-information"
  }, {
    path: "/search",
    component: _2673e8af,
    name: "search"
  }, {
    path: "/social-projects",
    component: _6b33fd26,
    name: "social-projects"
  }, {
    path: "/start",
    component: _749e70aa,
    name: "start"
  }, {
    path: "/support-measures",
    component: _37d0b9da,
    name: "support-measures"
  }, {
    path: "/survey",
    component: _28a10161,
    name: "survey"
  }, {
    path: "/survey-tips",
    component: _ae869858,
    name: "survey-tips"
  }, {
    path: "/unsubscribe",
    component: _085cd44c,
    name: "unsubscribe"
  }, {
    path: "/wifi",
    component: _69c6d642,
    name: "wifi"
  }, {
    path: "/about/books-articles",
    component: _3134784c,
    name: "about-books-articles"
  }, {
    path: "/about/contacts",
    component: _cf4998c2,
    name: "about-contacts"
  }, {
    path: "/about/events",
    component: _2f873d25,
    name: "about-events"
  }, {
    path: "/about/investors",
    component: _7b52e665,
    name: "about-investors"
  }, {
    path: "/about/mass-media",
    component: _7df428d7,
    name: "about-mass-media"
  }, {
    path: "/about/offices-and-atms",
    component: _6b84daf1,
    name: "about-offices-and-atms"
  }, {
    path: "/about/press",
    component: _6bcec94d,
    name: "about-press"
  }, {
    path: "/about/press-releases",
    component: _3e5a3662,
    name: "about-press-releases"
  }, {
    path: "/business/acquiring",
    component: _018bcd4e,
    name: "business-acquiring"
  }, {
    path: "/business/bank-agreement",
    component: _566dc498,
    name: "business-bank-agreement"
  }, {
    path: "/business/bank-guarantees",
    component: _7bb16dd2,
    name: "business-bank-guarantees"
  }, {
    path: "/business/business-crediting",
    component: _57fa66b7,
    name: "business-business-crediting"
  }, {
    path: "/business/client-bank",
    component: _2758a679,
    name: "business-client-bank"
  }, {
    path: "/business/corporate-cards",
    component: _1b88e736,
    name: "business-corporate-cards"
  }, {
    path: "/business/credit-holidays",
    component: _5ea46867,
    name: "business-credit-holidays"
  }, {
    path: "/business/energy-saving-investment",
    component: _6914077c,
    name: "business-energy-saving-investment"
  }, {
    path: "/business/fz106",
    component: _0f07139b,
    name: "business-fz106"
  }, {
    path: "/business/fz377",
    component: _f658e412,
    name: "business-fz377"
  }, {
    path: "/business/internet-acquiring",
    component: _69a93102,
    name: "business-internet-acquiring"
  }, {
    path: "/business/lead-magnet",
    component: _28a25e36,
    name: "business-lead-magnet"
  }, {
    path: "/business/leasing",
    component: _f286e65c,
    name: "business-leasing"
  }, {
    path: "/business/opening-and-maintaining-account",
    component: _c1ec3732,
    name: "business-opening-and-maintaining-account"
  }, {
    path: "/business/opening-and-maintaining-account-new",
    component: _2020f0fa,
    name: "business-opening-and-maintaining-account-new"
  }, {
    path: "/business/payment-qr",
    component: _332b2000,
    name: "business-payment-qr"
  }, {
    path: "/business/payments-from-individuals",
    component: _23104aef,
    name: "business-payments-from-individuals"
  }, {
    path: "/business/placement-of-funds-and-securities",
    component: _2c9231fc,
    name: "business-placement-of-funds-and-securities"
  }, {
    path: "/business/salary-projects",
    component: _57ec35d8,
    name: "business-salary-projects"
  }, {
    path: "/business/self-employed",
    component: _b66e60ee,
    name: "business-self-employed"
  }, {
    path: "/business/trade-finance",
    component: _057c8c69,
    name: "business-trade-finance"
  }, {
    path: "/business/transfer-b2b",
    component: _7ada7aaa,
    name: "business-transfer-b2b"
  }, {
    path: "/business/web-tsp",
    component: _9d87bf60,
    name: "business-web-tsp"
  }, {
    path: "/documents/dkbo",
    component: _ffdee0d6,
    name: "documents-dkbo"
  }, {
    path: "/esg/esg-library",
    component: _12f80b5a,
    name: "esg-esg-library"
  }, {
    path: "/esg/esg-rating",
    component: _6dd5774e,
    name: "esg-esg-rating"
  }, {
    path: "/for-individuals/biometric-data",
    component: _f7169a42,
    name: "for-individuals-biometric-data"
  }, {
    path: "/for-individuals/cards",
    component: _ba67a0d4,
    name: "for-individuals-cards"
  }, {
    path: "/for-individuals/centr-invest-online",
    component: _e6d91b4a,
    name: "for-individuals-centr-invest-online"
  }, {
    path: "/for-individuals/crediting",
    component: _087dda08,
    name: "for-individuals-crediting"
  }, {
    path: "/for-individuals/currency-rates",
    component: _4e223b5a,
    name: "for-individuals-currency-rates"
  }, {
    path: "/for-individuals/deposits",
    component: _11549e98,
    name: "for-individuals-deposits"
  }, {
    path: "/for-individuals/internet-bank-service",
    component: _0f25dec0,
    name: "for-individuals-internet-bank-service"
  }, {
    path: "/for-individuals/mobile-bank",
    component: _7accd5ba,
    name: "for-individuals-mobile-bank"
  }, {
    path: "/for-individuals/money-transfers",
    component: _06a2ad4e,
    name: "for-individuals-money-transfers"
  }, {
    path: "/for-individuals/mortgage",
    component: _128038df,
    name: "for-individuals-mortgage"
  }, {
    path: "/for-individuals/online-applications",
    component: _f72bd166,
    name: "for-individuals-online-applications"
  }, {
    path: "/for-individuals/property-deduction",
    component: _357d7b70,
    name: "for-individuals-property-deduction"
  }, {
    path: "/for-individuals/reference-information",
    component: _4a18ce1a,
    name: "for-individuals-reference-information"
  }, {
    path: "/for-individuals/refinancing",
    component: _5b738b92,
    name: "for-individuals-refinancing"
  }, {
    path: "/for-individuals/safe-boxes",
    component: _66293908,
    name: "for-individuals-safe-boxes"
  }, {
    path: "/for-individuals/sale-of-coins",
    component: _b0490676,
    name: "for-individuals-sale-of-coins"
  }, {
    path: "/for-individuals/securities",
    component: _717567a1,
    name: "for-individuals-securities"
  }, {
    path: "/for-individuals/service-rates",
    component: _005afea4,
    name: "for-individuals-service-rates"
  }, {
    path: "/for-individuals/tariffs-and-documents",
    component: _904a4f98,
    children: [{
      path: "",
      component: _00e967b7,
      name: "for-individuals-tariffs-and-documents"
    }, {
      path: "cards-docs",
      component: _9d9d0560,
      name: "for-individuals-tariffs-and-documents-cards-docs"
    }, {
      path: "dkbo-docs",
      component: _b6a4868e,
      name: "for-individuals-tariffs-and-documents-dkbo-docs"
    }, {
      path: "internet-bank-docs",
      component: _1016720b,
      name: "for-individuals-tariffs-and-documents-internet-bank-docs"
    }, {
      path: "mobile-bank-docs",
      component: _7b64966c,
      name: "for-individuals-tariffs-and-documents-mobile-bank-docs"
    }, {
      path: "payment-terminal-docs",
      component: _076c02ca,
      name: "for-individuals-tariffs-and-documents-payment-terminal-docs"
    }]
  }, {
    path: "/for-individuals/vip-service",
    component: _4c68a416,
    name: "for-individuals-vip-service"
  }, {
    path: "/promotions/new-clients-acquiring",
    component: _39f4ff6e,
    name: "promotions-new-clients-acquiring"
  }, {
    path: "/promotions/online-cashbox-free",
    component: _9f09837a,
    name: "promotions-online-cashbox-free"
  }, {
    path: "/promotions/resort-acquiring",
    component: _cd4d5bc2,
    name: "promotions-resort-acquiring"
  }, {
    path: "/promotions/starting-business",
    component: _2d13a556,
    name: "promotions-starting-business"
  }, {
    path: "/social-projects/career",
    component: _4b9b47da,
    name: "social-projects-career"
  }, {
    path: "/social-projects/medical-professionals",
    component: _5dca0378,
    name: "social-projects-medical-professionals"
  }, {
    path: "/wifi/avto",
    component: _45f7721a,
    name: "wifi-avto"
  }, {
    path: "/about/investors/experience",
    component: _2105852a,
    name: "about-investors-experience"
  }, {
    path: "/about/investors/international-activity",
    component: _e6bf22a4,
    name: "about-investors-international-activity"
  }, {
    path: "/about/investors/meetings-of-shareholders",
    component: _1f0c95c9,
    name: "about-investors-meetings-of-shareholders"
  }, {
    path: "/about/investors/principles",
    component: _e65c8412,
    name: "about-investors-principles"
  }, {
    path: "/about/investors/pub-info",
    component: _5ba4517e,
    name: "about-investors-pub-info"
  }, {
    path: "/about/investors/registrar",
    component: _37c703fa,
    name: "about-investors-registrar"
  }, {
    path: "/about/investors/regulatory-purp",
    component: _0198f7a4,
    name: "about-investors-regulatory-purp"
  }, {
    path: "/about/investors/reports",
    component: _3e62ef15,
    name: "about-investors-reports"
  }, {
    path: "/about/investors/shareholders",
    component: _d23c8ef0,
    name: "about-investors-shareholders"
  }, {
    path: "/about/investors/shareholders-notices",
    component: _076739d6,
    name: "about-investors-shareholders-notices"
  }, {
    path: "/about/investors/struct-controls",
    component: _08255d78,
    name: "about-investors-struct-controls"
  }, {
    path: "/about/investors/structure",
    component: _61776709,
    name: "about-investors-structure"
  }, {
    path: "/business/acquiring/instructionsqrlink",
    component: _152ff5b4,
    name: "business-acquiring-instructionsqrlink"
  }, {
    path: "/business/bank-agreement/form",
    component: _7d059e5c,
    name: "business-bank-agreement-form"
  }, {
    path: "/business/bank-agreement/sign-bki-form",
    component: _3d41fea3,
    name: "business-bank-agreement-sign-bki-form"
  }, {
    path: "/business/client-bank/info",
    component: _9af36352,
    name: "business-client-bank-info"
  }, {
    path: "/business/opening-and-maintaining-account/rko-currency",
    component: _5b5870a3,
    name: "business-opening-and-maintaining-account-rko-currency"
  }, {
    path: "/business/opening-and-maintaining-account/rko-special",
    component: _48d1f917,
    name: "business-opening-and-maintaining-account-rko-special"
  }, {
    path: "/for-individuals/cards/additional-card",
    component: _1fff1a8c,
    name: "for-individuals-cards-additional-card"
  }, {
    path: "/for-individuals/cards/card-features",
    component: _01a42d21,
    name: "for-individuals-cards-card-features"
  }, {
    path: "/for-individuals/cards/concierge-service",
    component: _c5407a42,
    name: "for-individuals-cards-concierge-service"
  }, {
    path: "/for-individuals/cards/debet-cards",
    component: _5406e2e6,
    name: "for-individuals-cards-debet-cards"
  }, {
    path: "/for-individuals/cards/rerelease-card",
    component: _92fe3596,
    name: "for-individuals-cards-rerelease-card"
  }, {
    path: "/for-individuals/cards/security",
    component: _0eb95d2c,
    name: "for-individuals-cards-security"
  }, {
    path: "/for-individuals/cards/short-card-request",
    component: _5fad0422,
    name: "for-individuals-cards-short-card-request"
  }, {
    path: "/for-individuals/cards/student-cards",
    component: _2c056b58,
    name: "for-individuals-cards-student-cards"
  }, {
    path: "/for-individuals/cards/teacher-card",
    component: _1c0d2487,
    name: "for-individuals-cards-teacher-card"
  }, {
    path: "/for-individuals/crediting/car-loans",
    component: _126432f7,
    name: "for-individuals-crediting-car-loans"
  }, {
    path: "/for-individuals/crediting/consumer-loan",
    component: _3acec7d4,
    name: "for-individuals-crediting-consumer-loan"
  }, {
    path: "/for-individuals/crediting/credit-cards",
    component: _1bc3d498,
    name: "for-individuals-crediting-credit-cards"
  }, {
    path: "/for-individuals/crediting/na-1-god",
    component: _31bfe20c,
    name: "for-individuals-crediting-na-1-god"
  }, {
    path: "/for-individuals/crediting/paket-dokumentov",
    component: _2dc716f8,
    name: "for-individuals-crediting-paket-dokumentov"
  }, {
    path: "/for-individuals/crediting/remote-payment-methods-for-loans",
    component: _2247781c,
    name: "for-individuals-crediting-remote-payment-methods-for-loans"
  }, {
    path: "/for-individuals/crediting/repayment-credits",
    component: _d6665f26,
    name: "for-individuals-crediting-repayment-credits"
  }, {
    path: "/for-individuals/crediting/self-employed",
    component: _308b6b90,
    name: "for-individuals-crediting-self-employed"
  }, {
    path: "/for-individuals/crediting/service-tariffs",
    component: _595d31e1,
    name: "for-individuals-crediting-service-tariffs"
  }, {
    path: "/for-individuals/crediting/useful-info",
    component: _150350af,
    name: "for-individuals-crediting-useful-info"
  }, {
    path: "/for-individuals/currency-rates/archive",
    component: _7c2fff4a,
    name: "for-individuals-currency-rates-archive"
  }, {
    path: "/for-individuals/money-transfers/golden-crown",
    component: _7e37b6b2,
    name: "for-individuals-money-transfers-golden-crown"
  }, {
    path: "/for-individuals/money-transfers/western-union",
    component: _04312a10,
    name: "for-individuals-money-transfers-western-union"
  }, {
    path: "/for-individuals/mortgage/bank-programm",
    component: _1b5cf9e7,
    name: "for-individuals-mortgage-bank-programm"
  }, {
    path: "/for-individuals/mortgage/building",
    component: _a7fab692,
    name: "for-individuals-mortgage-building"
  }, {
    path: "/for-individuals/mortgage/commercial-property",
    component: _6ee75545,
    name: "for-individuals-mortgage-commercial-property"
  }, {
    path: "/for-individuals/mortgage/green-mortgage",
    component: _56fcae2e,
    name: "for-individuals-mortgage-green-mortgage"
  }, {
    path: "/for-individuals/mortgage/it-mortgage",
    component: _bde80d6a,
    name: "for-individuals-mortgage-it-mortgage"
  }, {
    path: "/for-individuals/mortgage/it-mortgage-bank",
    component: _13fea1a4,
    name: "for-individuals-mortgage-it-mortgage-bank"
  }, {
    path: "/for-individuals/mortgage/large-family",
    component: _50a3548e,
    name: "for-individuals-mortgage-large-family"
  }, {
    path: "/for-individuals/mortgage/maternal-capital",
    component: _39a3460a,
    name: "for-individuals-mortgage-maternal-capital"
  }, {
    path: "/for-individuals/mortgage/mortgage-2",
    component: _98114ff8,
    name: "for-individuals-mortgage-mortgage-2"
  }, {
    path: "/for-individuals/mortgage/mortgage-children",
    component: _a22754c6,
    name: "for-individuals-mortgage-mortgage-children"
  }, {
    path: "/for-individuals/mortgage/mortgage-combo",
    component: _7e28ce60,
    name: "for-individuals-mortgage-mortgage-combo"
  }, {
    path: "/for-individuals/mortgage/mortgage-excellent-student",
    component: _50552a76,
    name: "for-individuals-mortgage-mortgage-excellent-student"
  }, {
    path: "/for-individuals/mortgage/mortgage-gc-a101",
    component: _2e0e5094,
    name: "for-individuals-mortgage-mortgage-gc-a101"
  }, {
    path: "/for-individuals/mortgage/mortgage-gc-pioneer",
    component: _3afc0c67,
    name: "for-individuals-mortgage-mortgage-gc-pioneer"
  }, {
    path: "/for-individuals/mortgage/mortgage-neometry",
    component: _7b551429,
    name: "for-individuals-mortgage-mortgage-neometry"
  }, {
    path: "/for-individuals/mortgage/mosprime",
    component: _0bb82311,
    name: "for-individuals-mortgage-mosprime"
  }, {
    path: "/for-individuals/mortgage/village",
    component: _56546e79,
    name: "for-individuals-mortgage-village"
  }, {
    path: "/for-individuals/property-deduction/form",
    component: _13afa8d4,
    name: "for-individuals-property-deduction-form"
  }, {
    path: "/for-individuals/refinancing/credit-refinancing",
    component: _97623f4a,
    name: "for-individuals-refinancing-credit-refinancing"
  }, {
    path: "/for-individuals/refinancing/mortgage-refinancing",
    component: _4df4bb3e,
    name: "for-individuals-refinancing-mortgage-refinancing"
  }, {
    path: "/for-individuals/service-rates/currency-rf",
    component: _7184d168,
    name: "for-individuals-service-rates-currency-rf"
  }, {
    path: "/for-individuals/service-rates/foreign-currency",
    component: _06659dbe,
    name: "for-individuals-service-rates-foreign-currency"
  }, {
    path: "/for-individuals/service-rates/tariff-terminals",
    component: _43ac723c,
    name: "for-individuals-service-rates-tariff-terminals"
  }, {
    path: "/for-individuals/services/real-estate-valuation",
    component: _61c01dde,
    name: "for-individuals-services-real-estate-valuation"
  }, {
    path: "/about/investors/pub-info/bailee-docs",
    component: _4d3f27d6,
    name: "about-investors-pub-info-bailee-docs"
  }, {
    path: "/about/investors/pub-info/bank-info",
    component: _3367cfe4,
    name: "about-investors-pub-info-bank-info"
  }, {
    path: "/about/investors/pub-info/bank-management",
    component: _622f4da3,
    name: "about-investors-pub-info-bank-management"
  }, {
    path: "/about/investors/pub-info/broker-docs",
    component: _861755c4,
    name: "about-investors-pub-info-broker-docs"
  }, {
    path: "/about/investors/pub-info/cliring-organization",
    component: _6864d117,
    name: "about-investors-pub-info-cliring-organization"
  }, {
    path: "/about/investors/pub-info/info-regulatory",
    component: _77d9a2f4,
    name: "about-investors-pub-info-info-regulatory"
  }, {
    path: "/about/investors/pub-info/inside-docs",
    component: _5f0f529b,
    name: "about-investors-pub-info-inside-docs"
  }, {
    path: "/about/investors/pub-info/kred-organization",
    component: _16052fee,
    name: "about-investors-pub-info-kred-organization"
  }, {
    path: "/about/investors/pub-info/licenses",
    component: _3e00974e,
    name: "about-investors-pub-info-licenses"
  }, {
    path: "/about/investors/pub-info/manager-docs",
    component: _477149bc,
    name: "about-investors-pub-info-manager-docs"
  }, {
    path: "/about/investors/pub-info/measure-docs",
    component: _25a08d51,
    name: "about-investors-pub-info-measure-docs"
  }, {
    path: "/about/investors/pub-info/organiz-torg",
    component: _a0627ebc,
    name: "about-investors-pub-info-organiz-torg"
  }, {
    path: "/about/investors/pub-info/polojenie-kval",
    component: _d58f2b86,
    name: "about-investors-pub-info-polojenie-kval"
  }, {
    path: "/about/investors/pub-info/registr-depo",
    component: _774cfcf8,
    name: "about-investors-pub-info-registr-depo"
  }, {
    path: "/about/investors/struct-controls/board-of-directors",
    component: _1061cd0e,
    name: "about-investors-struct-controls-board-of-directors"
  }, {
    path: "/for-individuals/cards/card-features/mir-pay",
    component: _6c664880,
    name: "for-individuals-cards-card-features-mir-pay"
  }, {
    path: "/for-individuals/cards/card-features/mirpass",
    component: _02be6114,
    name: "for-individuals-cards-card-features-mirpass"
  }, {
    path: "/for-individuals/cards/debet-cards/sticker",
    component: _d1c07690,
    name: "for-individuals-cards-debet-cards-sticker"
  }, {
    path: "/for-individuals/crediting/consumer-loan/car-loan",
    component: _20247bb7,
    name: "for-individuals-crediting-consumer-loan-car-loan"
  }, {
    path: "/for-individuals/crediting/consumer-loan/credit-for-all",
    component: _4de8ebb7,
    name: "for-individuals-crediting-consumer-loan-credit-for-all"
  }, {
    path: "/for-individuals/crediting/consumer-loan/credit-marketplace",
    component: _0568af65,
    name: "for-individuals-crediting-consumer-loan-credit-marketplace"
  }, {
    path: "/for-individuals/crediting/consumer-loan/potreb-goals",
    component: _317d79bb,
    name: "for-individuals-crediting-consumer-loan-potreb-goals"
  }, {
    path: "/for-individuals/crediting/credit-cards/credit-cards",
    component: _8ef38e8e,
    name: "for-individuals-crediting-credit-cards-credit-cards"
  }, {
    path: "/for-individuals/crediting/repayment-credits/credit-holidays",
    component: _2745acca,
    name: "for-individuals-crediting-repayment-credits-credit-holidays"
  }, {
    path: "/for-individuals/crediting/repayment-credits/fz-credit",
    component: _7f00002d,
    name: "for-individuals-crediting-repayment-credits-fz-credit"
  }, {
    path: "/for-individuals/crediting/repayment-credits/fz-delay",
    component: _5f3c5002,
    name: "for-individuals-crediting-repayment-credits-fz-delay"
  }, {
    path: "/for-individuals/crediting/repayment-credits/fz-mortgage",
    component: _c6bead60,
    name: "for-individuals-crediting-repayment-credits-fz-mortgage"
  }, {
    path: "/for-individuals/crediting/repayment-credits/fz-potreb",
    component: _1ce546ce,
    name: "for-individuals-crediting-repayment-credits-fz-potreb"
  }, {
    path: "/for-individuals/crediting/repayment-credits/restructuring",
    component: _9f96d710,
    name: "for-individuals-crediting-repayment-credits-restructuring"
  }, {
    path: "/",
    component: _1479741b,
    name: "index"
  }, {
    path: "/for-individuals/crediting/credit-cards/card/:slug?",
    component: _7d54b116,
    name: "for-individuals-crediting-credit-cards-card-slug"
  }, {
    path: "/for-individuals/cards/debet-cards/:slug",
    component: _57742576,
    name: "for-individuals-cards-debet-cards-slug"
  }, {
    path: "/for-individuals/cards/student-cards/:slug",
    component: _2a4eca10,
    name: "for-individuals-cards-student-cards-slug"
  }, {
    path: "/for-individuals/crediting/car-loans/:slug",
    component: _10ad91af,
    name: "for-individuals-crediting-car-loans-slug"
  }, {
    path: "/for-individuals/crediting/consumer-loan/:slug",
    component: _3918268c,
    name: "for-individuals-crediting-consumer-loan-slug"
  }, {
    path: "/for-individuals/crediting/credit-cards/:slug",
    component: _1a0d3350,
    name: "for-individuals-crediting-credit-cards-slug"
  }, {
    path: "/for-individuals/securities/exchange-traded-bonds/:id",
    component: _2fe9efe7,
    name: "for-individuals-securities-exchange-traded-bonds-id"
  }, {
    path: "/about/books-articles/:slug?",
    component: _2f7dd704,
    name: "about-books-articles-slug"
  }, {
    path: "/about/mass-media/:slug?",
    component: _7c3d878f,
    name: "about-mass-media-slug"
  }, {
    path: "/about/offices-and-atms/:slug?",
    component: _69ce39a9,
    name: "about-offices-and-atms-slug"
  }, {
    path: "/about/press-releases/:slug",
    component: _3ca3951a,
    name: "about-press-releases-slug"
  }, {
    path: "/business/business-crediting/:slug?",
    component: _5643c56f,
    name: "business-business-crediting-slug"
  }, {
    path: "/business/placement-of-funds-and-securities/:slug?",
    component: _2adb90b4,
    name: "business-placement-of-funds-and-securities-slug"
  }, {
    path: "/documents/dkbo/:slug",
    component: _7e59ee4d,
    name: "documents-dkbo-slug"
  }, {
    path: "/for-individuals/deposits/:slug",
    component: _4a2b47d3,
    name: "for-individuals-deposits-slug"
  }, {
    path: "/for-individuals/mortgage/:slug?",
    component: _10c99797,
    name: "for-individuals-mortgage-slug"
  }, {
    path: "/for-individuals/deposits/:slug?/banki-ru",
    component: _0f993972,
    name: "for-individuals-deposits-slug-banki-ru"
  }, {
    path: "/for-individuals/deposits/:slug?/new-offer",
    component: _4afc8bf0,
    name: "for-individuals-deposits-slug-new-offer"
  }, {
    path: "/documents/:slug",
    component: _698c3afc,
    name: "documents-slug"
  }, {
    path: "/for-individuals",
    component: _1479741b,
    name: "for-individuals"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
